import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { HttpService } from './http.service';
import { StorageService } from './storage.service';

@Injectable()
export class DomainService {
    private url: string = environment.base_url;

    constructor(
        private httpService: HttpService,
        private storageService: StorageService,
    ) {
    }

    isDomainVerified() {
        return this.storageService.get('domainVerified') === 'true';
    }

    saveDomainVerified(): void {
        this.storageService.set('domainVerified', 'true');
    }

    deleteDomainVerified(): void {
        this.storageService.delete('domainVerified');
    }

    saveFrontendSettings(data: any): void {
        this.storageService.set('frontend_settings', data);
    }

    private getFrontendSettings() {
        try {
            return JSON.parse(this.storageService.get('frontend_settings'));
        } catch (e) {
            return [];
        }
    }

    getFrontendLogo() {
        return this.getFrontendSettings()['site_logo'] ? this.getFrontendSettings()['site_logo'] : null;
    }

    getFrontendDomainName() {
        return this.getFrontendSettings()['domain_name'] ? this.getFrontendSettings()['domain_name'] : null;
    }
    getForgotPasswordLink(){
      return this.getFrontendSettings()['forgot_pass_link'] ? this.getFrontendSettings()['forgot_pass_link'] : null;
    }
    verify() {
        return this.httpService.get(this.url + '/domain').map(resp => resp);
    }

    getDomain() {
        const domain = window.location.hostname;
        if (environment.production) {
            return domain;
        }
        else {
            return (domain === 'localhost' || domain === '192.168.10.10') ? 'b2b.demostationer.com' : domain;
            // return (domain === 'localhost' || domain === '192.168.10.10') ? 'v2demo.inovocom.co.za' : domain;
        }
    }


}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/shared/services/domain.service.ts